<template>
    <div>
        <span v-if="$_.get(activity, 'payload.isDisabled')">
            {{ $t('notification.userDisabled', { 
                actor: $_.get(activity, 'actorUser.name'), 
                userName: $_.get(activity, 'payload.userName')
            }) }}
        </span>
        <span v-else>
            {{ $t('notification.userEnabled', { 
                actor: $_.get(activity, 'actorUser.name'), 
                userName: $_.get(activity, 'payload.userName')
            }) }}
        </span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "UserDisabled",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

